import { render, staticRenderFns } from "./AssignmentModal.vue?vue&type=template&id=2b7e796d&"
import script from "./AssignmentModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7e796d')) {
      api.createRecord('2b7e796d', component.options)
    } else {
      api.reload('2b7e796d', component.options)
    }
    module.hot.accept("./AssignmentModal.vue?vue&type=template&id=2b7e796d&", function () {
      api.rerender('2b7e796d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/AssignmentModal.vue"
export default component.exports